
  import ipxRuntime$wJZlfxlXII7sHBJbSEHBI7ARj_i4LGT6mkedH0Zq8_I from '/builds/skuby/miniapp-template/projects/web/node_modules/.bun/@nuxt+image@2.0.0+4f84fc6d29f7a7fb/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import skubyApiRuntime$pPDfyB8GbGGV3bhznpxb_45AyvXrI_45b_45GKI5mGsrSV8lA from '/builds/skuby/miniapp-template/projects/web/apps/web/config/image/ApiImageProvider.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "api.skuby.dev.alt-point.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$wJZlfxlXII7sHBJbSEHBI7ARj_i4LGT6mkedH0Zq8_I, defaults: {"maxAge":604800} },
  ['skubyApi']: { setup: skubyApiRuntime$pPDfyB8GbGGV3bhznpxb_45AyvXrI_45b_45GKI5mGsrSV8lA, defaults: undefined }
    }
  }
